import React from 'react';
import { twMerge } from 'tailwind-merge';

const Banner = ({ className, children }) => {
  return (
    <div
      className={twMerge(
        'p-0 w-full mx-auto my-0 bg-transparent transition-all duration-[0.4s] ease-[ease] delay-[0s]',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Banner;
